import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import StatusButton from '../../../../../../../../../../../../../components/StatusButton';
import { getStatusButtonMenuOptions } from '../../../../../../../../../../../../../components/StatusButton/reactQueryUtil';
import { CypressIds } from '../../../../../../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../../../../../constants/duskIds';
import { useUpdateRecordRequirements } from '../../../../../../../../../../../../../services/record-service';

import BaseDocumentCell from './BaseDocumentCell';
import EmptyStatusCell from './EmptyStatusCell';

const StatusCell = ({ document, requirement, recordId, insuredId }) => {
  const { insuranceDocumentTypeId, jobId, status } = requirement;
  const { mutate: updateRequirementStatus } = useUpdateRecordRequirements({ recordId, insuredId });
  const menuOptions = getStatusButtonMenuOptions(status, 'documents');

  const duskSelector = useMemo(() => InsuredProfilePageDuskIds.getDocumentRequirementStatusButton(insuranceDocumentTypeId), [requirement]);

  if (!document) return <EmptyStatusCell insuredId={insuredId} recordId={recordId} requirement={requirement} />;

  return (
    <StatusButton
      cypressId={CypressIds.documentStatusButton(insuranceDocumentTypeId)}
      duskSelector={duskSelector}
      id={document.id}
      isLoading={requirement?.isLoading}
      key={document.id}
      metadata={{
        documentTypeId: insuranceDocumentTypeId,
        jobId,
        insuredId,
        updateRequirementStatus,
        recordId
      }}
      options={menuOptions}
    />
  );
};

StatusCell.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
    statusLoading: PropTypes.bool
  }),
  requirement: PropTypes.shape({
    isLoading: PropTypes.bool,
    status: PropTypes.string,
    insuranceRequirementId: PropTypes.number,
    insuranceDocumentTypeId: PropTypes.number,
    jobId: PropTypes.number,
    insuredId: PropTypes.number
  }),
  recordId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired
};

export default BaseDocumentCell(StatusCell);
